export const DILEMMAS_STATUS = {
  DRAFT: "draft",
  SCHEDULED: "scheduled",
  PUBLISHED: "published",
  ARCHIVED: "archived",
  ACTIVE: "active",
  INACTIVE: "inactive",
  SUBMITTED: "submitted",
};
